import { render, staticRenderFns } from "./system-update-list.html?vue&type=template&id=2dfbb0d6&scoped=true&external"
import script from "./system-update-list.js?vue&type=script&lang=js&external"
export * from "./system-update-list.js?vue&type=script&lang=js&external"
import style0 from "./system-update-list.scss?vue&type=style&index=0&id=2dfbb0d6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbb0d6",
  null
  
)

export default component.exports